import { crearChecklistPorCTService, sesionActualPorCT } from './checklistPorCT';

const BASE = '/ci-generales';

export const sesionActualCIGenerales = sesionActualPorCT;

const base = crearChecklistPorCTService(BASE);

export const ciGeneralesService = {
    listarCts: base.listarCts,
    checklist: base.checklist,
    responder: base.responder,
    enviarReporte: base.enviarReporte,
    historial: base.historial,
    importarChecklistExcel: base.importarChecklistExcel,
    eliminarChecklist: base.eliminarChecklist,
};

export const descargarPlantillaChecklistCIGenerales = () => base.descargarPlantilla('plantilla_checklist_ci_generales.xlsx');

export const descargarReporteCIGenerales = (ct, sesion = null) => base.descargarReporte(ct, sesion, 'ci_generales');

export const descargarReporteExcelCIGenerales = (ct, sesion = null) => base.descargarReporteExcel(ct, sesion, 'ci_generales');

export const descargarReporteExcelInspectoriaCIGenerales = (sesion = null) => base.descargarReporteExcelInspectoria(sesion, 'ci_generales');
